module.exports = __webpack_public_path__ + "static/Freight-BigLight-9b770e67dd3a148a60d5ac671c8d3c35.woff2";